/*
  Вкладка «Дома» справочника: список домов портфеля и счета выбранного дома.

  🔴 Решение владельца 14.09.2026: вкладка живёт здесь же, рядом с участками и
  районными судами, - там, где дома заводят. Сразу видно и участок дома, и то,
  что под ним.

  Экран - контейнер: запросы и состояние держат `useHouses` и `useHouseAccounts`,
  таблицы получают всё пропсами. Страницы режет сервер (21.10.2026).
*/

import HouseAccounts from './HouseAccounts.jsx'
import HouseTable from './HouseTable.jsx'
import { Loading, Notice } from './Common.jsx'
import { useHouses } from './useHouses.js'

export default function HousesTab() {
  const { houses, error, bar, selected, select } = useHouses()

  if (error && !houses) return <Notice error={error} />
  if (!houses) return <Loading what="Читаем дома портфеля" />

  return (
    <>
      <p className="muted">
        Дома взяты из адресов помещений вашей выгрузки. Заведённый в справочнике дом несёт
        судебный участок - именно он подставится в заявление по счетам этого дома.
      </p>

      <HouseTable houses={houses} bar={bar} selected={selected} onSelect={select} />

      {/*
        Отказ на счетах показывает сама панель счетов, рядом с тем, что нажимали:
        при отказе она не рисует таблицу вовсе - человек видит одно объяснение,
        а не два противоречащих.
      */}
      {selected ? (
        <HouseAccounts key={selected} address={selected} />
      ) : houses.length > 0 ? (
        <p className="muted">Выберите дом в таблице, чтобы увидеть его лицевые счета.</p>
      ) : null}
    </>
  )
}
